import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NotificationContainer } from 'react-notifications';
var NotificationsContainer = function NotificationsContainer(_ref) {
  var stacked = _ref.stacked;
  var wrapperClasses = classNames('notification-container-wrapper', stacked && 'stacked');
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/React.createElement(NotificationContainer, null));
};
NotificationsContainer.defaultProps = {
  stacked: false
};
NotificationsContainer.propTypes = {
  stacked: PropTypes.bool
};
export default NotificationsContainer;